import React from 'react'
import { LoadingSpinner as BaseLoadingSpinner } from './ui/loading-spinner'
import { cn } from '../lib/utils'

interface LoadingSpinnerProps {
  message?: string
  size?: 'sm' | 'default' | 'lg'
  fullScreen?: boolean
  className?: string
}

export function LoadingSpinner({ 
  message = 'Carregando...', 
  size = 'default',
  fullScreen = false,
  className
}: LoadingSpinnerProps) {
  const content = (
    <BaseLoadingSpinner 
      message={message} 
      size={size}
      className={className}
    />
  )

  if (fullScreen) {
    return (
      <div className="fixed inset-0 bg-background/80 backdrop-blur-sm z-50 flex items-center justify-center">
        {content}
      </div>
    )
  }

  return content
}